export class Features {}

// Report Features
Features.GROUP_REPORTING = 'group_reporting'
Features.REPORT_EXCURSION = 'report_excursion'
Features.REPORT_DEVICE_SUMMARY = 'report_device_summary'
Features.REPORT_CALIBRATION = 'report_calibration'
Features.REPORT_MONTHLY_DATA_LOGS = 'report_monthly_data_logs'
Features.REPORT_STAR = 'report_star'
Features.REPORT_STAR_GRAPH_ADDENDUM = 'report_star_graph_addendum'
Features.REPORT_ALARM_RESOLUTION = 'report_alarm_resolution'
Features.REPORT_RYOBI_OIL_USAGE = 'report_ryobi_oil_usage'
Features.REPORT_THRESHOLD_ACHIEVEMENT = 'report_threshold_achievement'
Features.REPORT_LIGHT_SOUND = 'report_light_sound'
Features.REPORT_AVERAGE_PRESSURE = 'report_average_pressure'
Features.REPORT_MEAN_KINETIC_TEMPERATURE = 'report_mean_kinetic_temperature'
Features.REPORT_APPROVALS = 'report_approvals'

// Notifications
Features.NOTIFICATION_METHODS_EMAIL = 'notification_methods_email'
Features.NOTIFICATION_METHODS_PUSH = 'notification_methods_push'
Features.NOTIFICATION_METHODS_SMS = 'notification_methods_sms'
Features.NOTIFICATION_METHODS_VOICE = 'notification_methods_voice'

// Point
Features.POINT_VIEW_MULTI_HT = 'view_multi_ht'
Features.POINT_VIEW_MULTI_ALL = 'point_view_multi_all'

// Probes & Probe Histories
Features.PROBE_HISTORY = 'probe_history';

// Branding
Features.BRANDING_GRID_VIEW = 'branding_grid_view'
Features.BRANDING_ALL_FLOORPLANS_USER = 'branding_all_floorplans_user'
Features.BRANDING_ALL_FLOORPLANS_SONICU = 'branding_all_floorplans_sonicu'

// Validation
Features.VALIDATION_ALARM = 'validation_alarm';

// Maintenance Alarms
Features.POINT_MAINTENANCE_MODE = 'point_maintenance_mode';

// Tagging
Features.METER_TAGGING = 'meter_tagging';
